var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.number)?_c('a',{attrs:{"href":_vm.phoneNumber}},[_vm._v(_vm._s(_vm.number))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }